import { render, staticRenderFns } from "./preferential.vue?vue&type=template&id=78c35634"
import script from "./preferential.vue?vue&type=script&lang=js"
export * from "./preferential.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports